import { MessageItemComponent } from "./messageItem";

export const MessageItem = MessageItemComponent;
